module.exports = __webpack_public_path__ + "img/sort-icon-3.f7845c1f.png";